<template>
  <b-card
    no-body
    class="rounded-[8px] border-0 p-[8px] md:p-[12px] bg-white"
  >
    <!-- Header with Back Button and Title -->
    <div class="flex items-center mb-[12px]">
      <button
        type="button"
        class="inline-flex items-center justify-center w-[36px] h-[36px] bg-white border border-[#e5e7eb] rounded-[8px] text-[#374151] cursor-pointer transition-all duration-200 hover:bg-[#f9fafb] hover:border-[#d1d5db] hover:text-[#111827] focus:outline-none mr-[8px]"
        @click="$router.go(-1)"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="20"
        />
      </button>
      <h4 class="text-[18px] font-semibold text-[#1f2937] m-0">
        Edit Biaya Ekspedisi
      </h4>
    </div>

    <!-- Table Section -->
    <div class="border border-[#e5e7eb] rounded-[8px] overflow-hidden bg-white">
      <b-overlay
        :show="loadingData"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        class="w-full"
        rounded="sm"
      >
        <div class="table-responsive m-0">
          <table class="custom-ro-edit-table w-full mb-0">
            <thead>
              <tr>
                <th
                  rowspan="2"
                  class="th-expedition"
                >
                  Nama Ekspedisi
                </th>
                <th
                  colspan="2"
                  class="text-center min-w-[220px]"
                >
                  Ekspedisi
                </th>
                <th
                  colspan="2"
                  class="text-center min-w-[220px]"
                >
                  Pengguna
                </th>
              </tr>
              <tr>
                <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                  Cashback
                </th>
                <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                  Biaya COD
                </th>
                <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                  Cashback
                </th>
                <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                  Biaya COD
                </th>
              </tr>
            </thead>
            <tbody v-if="customListServices">
              <!-- Parent Expedition Row -->
              <tr class="expedition-row">
                <td>
                  <div class="flex items-center gap-[10px]">
                    <div class="inline-flex items-center justify-center w-[48px] h-[28px] bg-[#ffece9] rounded-full px-[8px] py-[3px]">
                      <img
                        :src="customListServices.image_logo"
                        :alt="customListServices.shipping_name"
                        class="max-h-[18px] max-w-[36px] object-contain"
                      >
                    </div>
                    <span class="text-[13.5px] font-semibold text-[#1f2937]">
                      {{ customListServices.shipping_name }}
                    </span>
                  </div>
                </td>
                <td />
                <td />
                <td />
                <td />
              </tr>

              <!-- Service Sub-rows with Inputs -->
              <tr
                v-for="(service, sIdx) in customListServices.services"
                :key="`service-${sIdx}`"
                class="service-row"
              >
                <td class="pl-[16px]">
                  <span class="inline-flex items-center gap-[6px] font-medium text-[#1f2937]">
                    <span class="text-[14px] leading-none text-[#1f2937]">•</span>
                    {{ service.service_name }}
                  </span>
                </td>

                <!-- Ekspedisi Cashback -->
                <td class="text-center">
                  <div
                    v-if="hasCashback(service)"
                    class="flex justify-center"
                  >
                    <div class="inline-flex items-center w-[86px] h-[34px] border border-[#e5e7eb] rounded-[6px] bg-white overflow-hidden transition-colors duration-150 focus-within:border-[#f95031]">
                      <input
                        v-model="service.cashback_from"
                        type="number"
                        class="w-[54px] h-full border-0 bg-transparent text-center text-[13px] text-[#1f2937] px-[4px] outline-none shadow-none"
                        @keypress="validateInput"
                      >
                      <span class="w-[32px] h-full flex items-center justify-center bg-[#f9fafb] border-l border-[#e5e7eb] text-[12px] font-medium text-[#6b7280] select-none">%</span>
                    </div>
                  </div>
                </td>

                <!-- Ekspedisi Biaya COD -->
                <td class="text-center">
                  <div class="flex justify-center">
                    <div class="inline-flex items-center w-[86px] h-[34px] border border-[#e5e7eb] rounded-[6px] bg-white overflow-hidden transition-colors duration-150 focus-within:border-[#f95031]">
                      <input
                        v-model="service.cod_fee_from"
                        type="number"
                        class="w-[54px] h-full border-0 bg-transparent text-center text-[13px] text-[#1f2937] px-[4px] outline-none shadow-none"
                        @keypress="validateInput"
                      >
                      <span class="w-[32px] h-full flex items-center justify-center bg-[#f9fafb] border-l border-[#e5e7eb] text-[12px] font-medium text-[#6b7280] select-none">%</span>
                    </div>
                  </div>
                </td>

                <!-- Pengguna Cashback -->
                <td class="text-center">
                  <div
                    v-if="hasCashback(service)"
                    class="flex justify-center"
                  >
                    <div class="inline-flex items-center w-[86px] h-[34px] border border-[#e5e7eb] rounded-[6px] bg-white overflow-hidden transition-colors duration-150 focus-within:border-[#f95031]">
                      <input
                        v-model="service.cashback_to"
                        type="number"
                        class="w-[54px] h-full border-0 bg-transparent text-center text-[13px] text-[#1f2937] px-[4px] outline-none shadow-none"
                        @keypress="validateInput"
                      >
                      <span class="w-[32px] h-full flex items-center justify-center bg-[#f9fafb] border-l border-[#e5e7eb] text-[12px] font-medium text-[#6b7280] select-none">%</span>
                    </div>
                  </div>
                </td>

                <!-- Pengguna Biaya COD -->
                <td class="text-center">
                  <div class="flex justify-center">
                    <div class="inline-flex items-center w-[86px] h-[34px] border border-[#e5e7eb] rounded-[6px] bg-white overflow-hidden transition-colors duration-150 focus-within:border-[#f95031]">
                      <input
                        v-model="service.cod_fee_to"
                        type="number"
                        class="w-[54px] h-full border-0 bg-transparent text-center text-[13px] text-[#1f2937] px-[4px] outline-none shadow-none"
                        @keypress="validateInput"
                      >
                      <span class="w-[32px] h-full flex items-center justify-center bg-[#f9fafb] border-l border-[#e5e7eb] text-[12px] font-medium text-[#6b7280] select-none">%</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-end items-center gap-[12px] mt-[16px]">
      <button
        type="button"
        class="px-[24px] py-[8px] text-[13px] font-medium rounded-[8px] border border-[#e5e7eb] bg-white text-[#374151] cursor-pointer transition-all duration-200 hover:bg-[#f9fafb] hover:border-[#d1d5db] disabled:opacity-50 disabled:cursor-not-allowed disabled:text-[#9ca3af] focus:outline-none"
        :disabled="isUnchanged"
        @click="resetCondition"
      >
        Reset
      </button>
      <button
        type="button"
        class="px-[24px] py-[8px] text-[13px] font-medium rounded-[8px] border-0 bg-[#f95031] text-white cursor-pointer transition-all duration-200 hover:bg-[#e03e21] disabled:opacity-50 disabled:bg-[#d1d5db] disabled:cursor-not-allowed focus:outline-none"
        :disabled="isUnchanged"
        @click="setChangeExpeditionFee"
      >
        Simpan
      </button>
    </div>

    <!-- Modals -->
    <ModalChangeExpeditionFee
      :change-values="changeValues"
      :shipping-name="shippingName"
      @on-click-confirm-button="updateExpeditionFee"
    />
  </b-card>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ModalChangeExpeditionFee from './component/ModalChangeExpeditionFee.vue'

export default {
  name: 'ROEditExpeditionFee',
  components: {
    ModalChangeExpeditionFee,
  },
  data() {
    return {
      loadingData: true,
      defaultListServices: null,
      customListServices: null,
      changeValues: [],
      shippingName: '',
      source: 'komship',
    }
  },
  computed: {
    isUnchanged() {
      if (!this.defaultListServices || !this.customListServices) return true
      if (!this.defaultListServices.services || !this.customListServices.services) return true
      if (this.defaultListServices.services.length !== this.customListServices.services.length) return false

      const fields = [
        'cashback_from',
        'cod_fee_from',
        'cashback_to',
        'cashback_to_juragan',
        'cashback_to_saudagar',
        'cod_fee_to',
      ]

      return this.customListServices.services.every((srv, i) => {
        const orig = this.defaultListServices.services[i]
        if (!orig) return false

        return fields.every(field => {
          const srvVal = srv[field]
          const origVal = orig[field]

          const isSrvEmpty = srvVal === null || srvVal === undefined || srvVal === ''
          const isOrigEmpty = origVal === null || origVal === undefined || origVal === ''

          if (isSrvEmpty && isOrigEmpty) return true
          if (isSrvEmpty || isOrigEmpty) {
            return Number(srvVal || 0) === Number(origVal || 0)
          }

          return Number(srvVal) === Number(origVal)
        })
      })
    },
  },
  mounted() {
    this.resetCondition()
  },
  methods: {
    hasCashback(service) {
      if (!service || !service.service_name) return true
      return !service.service_name.toLowerCase().includes('flat')
    },
    setChangeExpeditionFee() {
      const changes = []
      const fields = [
        'cashback_from',
        'cod_fee_from',
        'cashback_to',
        'cashback_to_juragan',
        'cashback_to_saudagar',
        'cod_fee_to',
      ]

      this.customListServices.services.forEach((srv, i) => {
        const orig = this.defaultListServices.services[i]
        const diff = {}

        fields.forEach(field => {
          diff[`${field}_old`] = Number(orig[field])
          diff[`${field}_new`] = Number(srv[field])
        })

        changes.push({
          id: srv.id,
          service_name: srv.service_name,
          is_changed: this.hasChanged(diff),
          ...diff,
        })
      })

      this.changeValues = changes
      this.$bvModal.show('modal-change-expedition-fee')
    },
    hasChanged(diff) {
      return Object.keys(diff).some(key => {
        if (key.endsWith('_new')) {
          const oldKey = key.replace('_new', '_old')
          return diff[key] !== diff[oldKey]
        }
        return false
      })
    },
    resetCondition() {
      const original = cloneDeep(this.$route.params)

      if (!original || Object.keys(original).length === 0) {
        this.$router.push({ name: 'skema-ekspedisi' })
        return
      }

      this.defaultListServices = original
      this.customListServices = cloneDeep(original)
      this.shippingName = this.defaultListServices.shipping_name || ''
      this.source = this.$route.params.source || this.$route.query.source || 'komship'
      this.changeValues = []
      this.loadingData = false
    },
    validateInput(evt) {
      const char = String.fromCharCode(evt.which ?? evt.keyCode)
      const input = evt.target.value + char

      // Izinkan: angka atau titik
      if (!/^\d*\.?\d*$/.test(input)) {
        evt.preventDefault()
        return false
      }

      // Cegah titik kedua
      if (char === '.' && evt.target.value.includes('.')) {
        evt.preventDefault()
        return false
      }

      // Cegah nilai lebih dari 100
      const value = parseFloat(input)
      if (!Number.isNaN(value) && value > 100) {
        evt.preventDefault()
        return false
      }

      return true
    },
    updateExpeditionFee() {
      const url = `/komship/api/v1/admin/shipment/configure/cost/${encodeURIComponent(this.shippingName.toLowerCase())}?source=${this.source}`

      const params = this.changeValues
        .filter(item => item.is_changed)
        .map(item => ({
          id: item.id,
          service_name: item.service_name,
          cashback_from: item.cashback_from_new,
          cod_fee_from: item.cod_fee_from_new,
          cashback_to: item.cashback_to_new,
          cashback_to_juragan: item.cashback_to_juragan_new,
          cashback_to_saudagar: item.cashback_to_saudagar_new,
          cod_fee_to: item.cod_fee_to_new,
        }))

      this.$http_new.put(url, params)
        .then(() => {
          this.$bvModal.hide('modal-change-expedition-fee')
          this.$toast_success({ message: 'Biaya ekspedisi berhasil diubah' })
          this.$router.push({ name: 'skema-ekspedisi' })
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal Melakukan Perubahan Biaya Ekspedisi' })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-ro-edit-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 0;

  thead th {
    background-color: #f8f9fa !important;
    color: #1f2937 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    border: none !important;
    border-bottom: 1px solid #e5e7eb !important;
    border-right: 1px solid #e5e7eb !important;
    padding: 10px 14px !important;
    vertical-align: middle !important;
    text-transform: none !important;
  }

  thead th:last-child {
    border-right: none !important;
  }

  .th-expedition {
    width: 320px;
    min-width: 260px;
    text-align: left;
  }

  /* Expedition Parent Row */
  .expedition-row {
    background-color: #fff5f2 !important;

    td {
      padding: 9px 14px !important;
      vertical-align: middle !important;
      border: none !important;
      border-bottom: 1px solid #f3f4f6 !important;
      background-color: inherit;
    }
  }

  /* Service Sub-row */
  .service-row {
    td {
      background-color: #ffffff;
      padding: 8px 14px !important;
      font-size: 13px !important;
      color: #1f2937;
      vertical-align: middle !important;
      border: none !important;
      border-bottom: 1px solid #f3f4f6 !important;
    }
  }

  @media (max-width: 768px) {
    .th-expedition {
      width: 240px;
      min-width: 200px;
    }
  }
}

/* Hide number input spinners */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
